import { useAction, useAtom } from "@reatom/npm-react";
import { useDebounce } from "@uidotdev/usehooks";
import {
  Icon12Dropdown,
  Icon20FunnelOutline,
  Icon20ListBulletOutline,
  Icon20MenuOutline,
} from "@vkontakte/icons";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { toggleModal } from "../../core/reatom/state/modal/modal";
import {
  paramsAtom,
  professionIdsAtom,
  searchInputAtom,
  searchListScrollPositionAtom,
  updateParamsAction,
} from "../../core/reatom/state/search/search";
import { CategoriesPatchMapper } from "../CategoriesPatchMapper/CategoriesPatchMapper";
import { SearchInput } from "../SearchInput/SearchInput";
import { UIButton } from "../UIButton/UIButton";
import s from "./style.module.scss";
import { Block } from "@/components/Block/Block";
import useTheme from "@/core/hooks/useTheme";

export const Filter = () => {
  const theme = useTheme();
  const handleToggleModal = useAction(toggleModal);
  const [value, setValue] = useAtom(searchInputAtom);
  const debouncedSearch = useDebounce(value, 200);
  const [params] = useAtom(paramsAtom);
  const handleParams = useAction(updateParamsAction);
  const [scrollPosition] = useAtom(searchListScrollPositionAtom);
  const [professionIds] = useAtom(professionIdsAtom);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const scrollDelta = Math.abs(scrollPosition - lastScrollY);

  useEffect(() => {
    if (params.search_text !== debouncedSearch) {
      handleParams({ search_text: debouncedSearch });
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (scrollDelta > 100) {
      if (scrollPosition > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(scrollPosition);
    }
  }, [scrollPosition, lastScrollY]);

  return (
    <Block
      borderRadius="bottom"
      className={clsx(s.filterWrapper, !isVisible && s.hidden)}
    >
      <div className={s.filter}>
        <div className={s.buttons}>
          <UIButton
            id="categories"
            fontType={"semibold"}
            color="green"
            className={clsx(s.categoryButton, s.services)}
            onClick={() => handleToggleModal("categories")}
          >
            <Icon20MenuOutline className={s.servicesIcon} />
            {`Категории`}
            <Icon12Dropdown width={16} height={12} className={s.servicesIcon} />
          </UIButton>
          <UIButton
            id="subcategories"
            fontType={"medium"}
            color="white"
            className={clsx(s.categoryButton, s.subcategories)}
            onClick={() => handleToggleModal("subCategories")}
          >
            <div>
              <Icon20ListBulletOutline className={s.icons} width={20} />
              <p className={s.subcategoriesText}>{`Подкатегории`}</p>
            </div>

            <div>
              {!!professionIds?.length && (
                <p className={s.count}>{professionIds?.length}</p>
              )}
              <Icon12Dropdown width={16} height={12} className={s.icons} />
            </div>
          </UIButton>
        </div>
        <div className={s.patches}>
          <CategoriesPatchMapper />
        </div>
        <div className={s.search}>
          <SearchInput
            value={value}
            onChange={(e) => setValue(e.target.value)}
            reset={() => setValue("")}
            className={s.searchInput}
          />
          <UIButton
            id="filter"
            fontType={"semibold"}
            color="white"
            className={clsx(s.iconButton, s.filterButton)}
            onClick={() => handleToggleModal("filterForm")}
          >
            <Icon20FunnelOutline
              fill={theme === "light" ? "#003919" : "#fff"}
            />
          </UIButton>
        </div>
      </div>
    </Block>
  );
};
